import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useLocation } from "react-router-dom";

import Footer from "./Footer";
import Header from "./Header";

import { AUTH_ROUTES, FOOTER_HIDDEN_ROUTES } from "../globals/constants";
import { checkIfPatchIsActive } from "../globals/utils/locationUtils";

import "./Layout.scss";

const Layout = ({ children }) => {
  const location = useLocation();
  const [isLayoutHidden, setisLayoutHidden] = useState(false);
  const [isFooterHidden, setisFooterHidden] = useState(false);

  useEffect(() => {
    if (AUTH_ROUTES.some((authRoute) => authRoute === location.pathname)) {
      setisLayoutHidden(true);
    } else {
      setisLayoutHidden(false);
    }

    // Hide Footer
    if (
      FOOTER_HIDDEN_ROUTES.some((footerHiddenRoute) =>
        checkIfPatchIsActive(location, footerHiddenRoute)
      )
    ) {
      setisFooterHidden(true);
    } else {
      setisFooterHidden(false);
    }
  }, [location.pathname]);

  return (
    <div className="Layout d-flex flex-column">
      {!isLayoutHidden && <Header />}

      <div className="Layout__Injection flex-fill">{children}</div>

      {!isLayoutHidden && !isFooterHidden ? <Footer /> : <></>}
    </div>
  );
};

export default Layout;

Layout.propTypes = {
  children: PropTypes.node,
};
